import { AddressRequirement } from './available-phone-number.i';
var AvailablePhoneNumberBuilder = /** @class */ (function () {
    function AvailablePhoneNumberBuilder() {
        this.availablePhoneNumber = {
            number: '',
            countryCode: '',
            locality: '',
            tollFree: false,
            price: 0,
            addressRequirement: AddressRequirement.NONE,
        };
    }
    AvailablePhoneNumberBuilder.prototype.withNumber = function (number) {
        this.availablePhoneNumber.number = number;
        return this;
    };
    AvailablePhoneNumberBuilder.prototype.withCountryCode = function (countryCode) {
        this.availablePhoneNumber.countryCode = countryCode;
        return this;
    };
    AvailablePhoneNumberBuilder.prototype.withLocality = function (locality) {
        this.availablePhoneNumber.locality = locality;
        return this;
    };
    AvailablePhoneNumberBuilder.prototype.withTollFree = function (tollFree) {
        this.availablePhoneNumber.tollFree = tollFree;
        return this;
    };
    AvailablePhoneNumberBuilder.prototype.withPrice = function (price) {
        this.availablePhoneNumber.price = price;
        return this;
    };
    AvailablePhoneNumberBuilder.prototype.withAddressRequirement = function (addressRequirement) {
        this.availablePhoneNumber.addressRequirement = addressRequirement;
        return this;
    };
    AvailablePhoneNumberBuilder.prototype.build = function () {
        return this.availablePhoneNumber;
    };
    return AvailablePhoneNumberBuilder;
}());
export { AvailablePhoneNumberBuilder };
//# sourceMappingURL=available-phone-number.builder.js.map